import { Component, OnInit, ViewChild,Pipe, PipeTransform } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpModule, Http, URLSearchParams, Headers, RequestOptions } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedservicesService } from '../../../../services/sharedservices.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {DomSanitizer} from "@angular/platform-browser";
// import { YoutubePlayerModule } from 'ngx-youtube-player';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  step = 0;
  thetype;
  newurl;
  uurl;
  heading: any;
  status: any;
  catId: any;
  Url;
  pageId : any;
  youtubeUrl: any;
  youtubeId = "iHhcHTlGtRs";
  apiRoot: string = this.ref.GetPostURL(); //search URL
  result: any;
  pilot: any;
  getUserComplaint: any;
  private player;
  private ytEvent;
  information: any;
  custemail: any;
  FinalData: any;
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  public data: any;
  id: string;
  type: string;

  constructor(private router: Router, private http: HttpClient, private ref: SharedservicesService, private route: ActivatedRoute, private domSanitizer : DomSanitizer) { 
    var userLoggedin = JSON.parse(localStorage.getItem('customerInfo'));
    if (!userLoggedin) {
      this.router.navigate(['/']);
    } else {
      setTimeout(() => {
        (<HTMLElement>document.querySelector('#loader-wrapper1')).style.display = 'none';
      }, 1200); 
    }
    this.route.queryParams.subscribe(params => {
      this.heading = params['heading'];
      this.status = params['status'];
      this.custemail = params['custemail'];
      // this.ref.telecastcomplaint.subscribe(async(data) => {
      //   this.information = await data;
      //   this.catId = this.information.Id;
      //   console.log(this.catId)
      // });
      var complaintId = JSON.parse(localStorage.getItem('customerId'));
      if(complaintId.Id) {
        this.catId = complaintId.Id;
      } 
      this.get_details(this.heading, this.status, this.custemail);
      var video = <HTMLInputElement>document.getElementById('vid');
    });
  }
  get_details(heading, status, custemail) {
    var userLoggedin = JSON.parse(localStorage.getItem('customerInfo'));
    if (userLoggedin) {
      const posturl2: string = this.apiRoot + 'user/fetch/complaint';
      var userComplaintdetails = {
        'email': userLoggedin.email,
        'customeremail': custemail,
        'auth': userLoggedin.auth,
        'token': userLoggedin.token,
        'userType': userLoggedin.usertype
      };
      if (userComplaintdetails.userType === 'useragent') {
        var agentgetcustdetails = {
          'email': userLoggedin.email,
          'customeremail': custemail,
          'auth': userLoggedin.auth,
          'token': userLoggedin.token,
          'userType': userLoggedin.usertype,
          'heading': heading,
          'status': status
        }
        this.fetchDataDetails(agentgetcustdetails, 'useragent');
      } else if(userComplaintdetails.userType === 'usercustomer') {
        var custComplaintdetails = {
          'email': userLoggedin.email,
          'auth': userLoggedin.auth,
          'token': userLoggedin.token,
          'userType': userLoggedin.usertype,
          'heading': heading,
          'status': status
        }
        this.fetchDataDetails(custComplaintdetails, 'usercustomer');
      }
    } else {
      console.log('user not logged in');
    }

  }
  fetchDataDetails(userComplaintdetails, status) {
    if (status === 'useragent') {
      this.ref.FetchAgentComplaints(userComplaintdetails).subscribe((res) => {
        if (res) {
          const result = JSON.parse(JSON.stringify(res));
          this.getUserComplaint = result;
          this.FinalData = this.getUserComplaint[0];
        }
      },
        err => {
          console.log(err);
          console.log('Data not fetched');
        }
      );
    } else {
      this.ref.FetchCustomerComplaints(userComplaintdetails).subscribe((res) => {
        if (res) {
          const result = JSON.parse(JSON.stringify(res));
          this.getUserComplaint = result;
          this.FinalData = this.getUserComplaint[0];
        }
      },
        err => {
          console.log(err);
          console.log('Data not fetched');
        }
      );
    }
    // this.http.post(posturl, userComplaintdetails).subscribe(async (res) => {
    //   if (res) {
    //     this.getUserComplaint = await res;
    //     this.FinalData = this.getUserComplaint[0];
    //   }
    // },
    //   err => {
    //     console.log(err);
    //     console.log('Data not fetched');
    //   }
    // );
  }
  ngOnInit() {
  }

}
